// src/components/common/NotificationContainer.jsx

import React from "react";
import { createPortal } from "react-dom";
import { useNotification } from "../../contexts/NotificationContext"; // Assurez-vous que le chemin est correct
import NotificationToast from "./NotificationToast"; // Le composant de toast individuel

const NotificationContainer = () => {
  // 1. Récupération des notifications et de la fonction de suppression depuis le contexte
  const { notifications, removeNotification } = useNotification();

  // 2. Le conteneur principal des notifications
  const container = (
    <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
      {notifications.map((notification) => (
        // 3. Affichage de chaque toast
        <NotificationToast
          key={notification.id}
          // Passage de toutes les propriétés de la notification au Toast
          {...notification}
          // La fonction de fermeture (onClose) doit appeler removeNotification
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );

  // 4. Création du Portal : Affiche le conteneur dans le body du document
  // L'utilisation d'un portail garantit que les notifications sont toujours au-dessus de tout (z-index élevé).
  return createPortal(container, document.body);
};

export default NotificationContainer;
